import create from 'utils/command'

const hooks =  [
    {paths: ['refreshProfile/'], resolves:[refreshProfile]},
    {paths:['page/','preferences/pendingRefresh'], resolves: [loadPreferences]}
]

export {hooks as default}

export async function refreshProfile({update}) {
  const [info] = await create('public', 'myinfo')()
  update({info: {$set: info}})
}

export async function loadPreferences({state, update}) {

  const {preferences} = state

  if (!preferences.pendingRefresh) return

  update({preferences: {loaded: {$set: false}}})

  const [properties] = await create('public', 'preferences')()

  if (!properties.notifications) properties.notifications = {}

  update({preferences: {
    properties: {$set: properties},
    loaded: {$set: true},
    pendingRefresh: {$set: false}
  }})

}